import React from 'react'
import Navbar from '../components/Home/Navbar/Navbar'
import Turf from '../components/Services08/Turf'
import Turfdetails from '../components/Services08/Turfdetails'
import Footer from '../components/Home/Footer/Footer'
import Appointment from '../components/About/Appointment'

const Turfpage = () => {
    return (
        <div>

        <Navbar/>
        <main>
        <Turf/>
        <Turfdetails/>
        <Appointment/>
        </main>
        <Footer/>
        



        </div>
    )
}

export default Turfpage
